import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import App from './App.vue'
import router from '@/router/router'
import * as VueGoogleMaps from 'vue2-google-maps'
import store from '@/store'
import VueMarqueeSlider from 'vue-marquee-slider'
import { initAnalytics } from '@/analytics'
import InfoTip from '@/components/InfoTip'

initAnalytics()

Vue.use(VueMarqueeSlider)
// the explanations on hover / on a tap, everywhere
Vue.component('InfoTip', InfoTip)

Vue.use(VueGoogleMaps, {
    load: {
        key: 'AIzaSyD1kSW4Y1zf2SBhqIHE4JhvLWODN9ZkvuI',
        libraries: 'places'
    }
})

Vue.config.productionTip = false
Vue.use(Vuetify)

new Vue({
    router,
    store,
    vuetify: new Vuetify(),
    render: h => h(App)
}).$mount('#app')
